import { get } from '../utils';
import { MediaItemType } from '../defenitions';
import { parseMediaItemUri } from '../Media/mediaUtils';
var buildImage = function (mediaItem) {
    var title = get(function () { return mediaItem.title; }, '');
    return {
        id: mediaItem.id,
        src: buildImageUrl(mediaItem),
        description: '',
        title: title,
        link: undefined,
        type: 'Image',
    };
};
var buildVideo = function (mediaItem) {
    if (!mediaItem.video || !mediaItem.video.files || !mediaItem.video.files.length) {
        return null;
    }
    var firstVideo = mediaItem.video.files[0];
    var imageData = get(function () { return mediaItem.thumbnail.url.split('/').reverse(); }, []);
    var videoData = get(function () { return firstVideo.url.split('/').reverse(); }, []);
    var uri = get(function () { return videoData[3]; }, '');
    var filename = get(function () { return videoData[0]; }, 'file');
    var title = get(function () { return mediaItem.title; }, '');
    var posterUri = get(function () { return imageData[4]; }, '');
    var posterWidth = get(function () { return firstVideo.width; }, 100);
    var posterHeight = get(function () { return firstVideo.height; }, 100);
    return {
        id: mediaItem.id,
        src: "wix:video://v1/" + uri + "/" + filename + "#posterUri=" + posterUri + "&posterWidth=" + posterWidth + "&posterHeight=" + posterHeight,
        description: '',
        title: title,
        link: undefined,
        type: 'Video',
        thumbnail: buildImageUrl(mediaItem),
    };
};
export var mediaToGalleryItem = function (mediaItem) {
    if (!mediaItem) {
        return;
    }
    if (mediaItem.mediaType === MediaItemType.video) {
        return buildVideo(mediaItem);
    }
    else {
        return buildImage(mediaItem);
    }
};
export var buildImageUrl = function (mediaItem) {
    var missingMedia = {
        url: 'https://static.wixstatic.com/media/614034_103e8f4ab0ae4536a38b319d3eb437ed~mv2.png/v1/fill/w_500,h_500/missing-media.png',
        width: 500,
        height: 500,
    };
    var media = mediaItem
        ? mediaItem.mediaType === MediaItemType.video
            ? mediaItem.thumbnail
            : mediaItem.image
        : missingMedia;
    var imageData = get(function () { return media.url.split('/').reverse(); }, []);
    var uri = get(function () { return imageData[4]; }, '');
    var fileName = get(function () { return imageData[0]; }, 'file');
    return "wix:image://v1/" + uri + "/" + fileName + "#originWidth=" + media.width + "&originHeight=" + media.height;
};
export var mediaMapper = function (media) { return ({
    mainMedia: (media || null) && buildImageUrl(media.mainMedia),
    mediaItems: ((media && media.items) || []).map(mediaToGalleryItem).filter(Boolean),
}); };
export var getCreateOrderMediaSrc = function (src) {
    if (!src) {
        return {};
    }
    if (src.toLocaleLowerCase().startsWith('http')) {
        return { externalImageUrl: src };
    }
    if (src.toLocaleLowerCase().startsWith('wix:')) {
        var parsedMediaItem = parseMediaItemUri(src);
        return { id: parsedMediaItem.mediaId };
    }
};
//# sourceMappingURL=mappers.js.map